/**
 * Creates an array from the given value.
 *
 * - Returns a value that is an array already.
 * - Returns an empty array if the value is nullish.
 * - Converts an array-like value to an array.
 * - Wraps a not array-like value in an array
 *
 * @param value - The value to create an array from
 * @return The existing or created array
 */
export function array<T = unknown> (value?: T | ArrayLike<T> | T[]): T[] {
  if (value == null) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === 'object' && 'length' in value) {
    return Array.from(value);
  }
  return [ value ];
}
